// IMPORTS
// Modules
import { useState } from 'react';
// OHS
import { OHSFormItem, OHSFormSubmit, OHSFormSubmitListener, OHSFormDataExtractor, OHSFormSelectBuilder } from '../../../../../onehivesystems/js/OHSForm';
import OHSCRUD from '../../../../../onehivesystems/js/OHSCRUD';


// COMPONENT
export default function Commands (props) {
   // Functions
   const executeCommand = function () {
      OHSCRUD({
         url: '/v1/oneport/commands/' + props.parent.deviceID,
         method: 'POST',
         payload: OHSFormDataExtractor('oneport-device-commands'),
         success: function (data) {
            props.parent.setCommandResults(data);
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         setOHSConfirmation: props.onehive.setConfirmation,
         showSuccessPopup: true,
         confirmMessage: "ATTENTION - Executing this SSH command could cause connection loss on the device or unexpected configuration changes if commands are not configured correctly. Are you sure you wish to proceed?"
      });
   }

   // Component
   return (
      <div id='oneport-device-commands' className='oneport-device-commands' onKeyDown={(e) => {OHSFormSubmitListener(e, executeCommand);}}>
         <OHSFormItem onehive={props.onehive} title="Command">
            <OHSFormSelectBuilder onehive={props.onehive} content={props.parent.commands} field={"name"} blank={false} ohsformdata='command_id' />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Port">
            <OHSFormSelectBuilder onehive={props.onehive} content={props.parent.ports} field={"name"} blank={false} ohsformdata='port_id' />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Results">
            <textarea className='ohsinput-terminal' defaultValue={props.parent.commandResults}></textarea>
         </OHSFormItem>
         <OHSFormSubmit onehive={props.onehive} custom={[
            {
               title: "Run Commands",
               action: executeCommand,
               class: "ohsbtn"
            }
         ]} keyListener={true} />
      </div>
   );
}